import { render, staticRenderFns } from "./health-records.html?vue&type=template&id=53d04e64&scoped=true&external"
import script from "./health-records.js?vue&type=script&lang=js&external"
export * from "./health-records.js?vue&type=script&lang=js&external"
import style0 from "./health-records.scss?vue&type=style&index=0&id=53d04e64&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d04e64",
  null
  
)

export default component.exports